import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * @param {{ year: number, empresa?: string, mes?: number, nivel1?: string, omitirGeneralStage?: boolean, rol?: 'ceo'|'cfo'|'ambos' }} params
 */
export async function fetchExecutiveBriefing(params = {}) {
  const res = await axios.get(`${API_URL}/api/finanzas/briefing`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function fetchExecutiveAlertas(params = {}) {
  const res = await axios.get(`${API_URL}/api/finanzas/briefing/alertas`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}
